import { EnrichmentCard } from './EnrichmentCard';
import type { VenueCreateForm } from './useVenueCreateForm';
import { Field, fieldStyle, hintText, MONO } from './venueCreateFields';

export function IdentityStep({ form }: { form: VenueCreateForm }) {
  const { stage, setStage, fields, edit, fieldError } = form;
  const stages = [
    { id: 'active' as const, label: 'Active', hint: 'ready to book workshops' },
    { id: 'prospect' as const, label: 'Prospect', hint: 'just recruiting — light record' },
  ];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <Field label="Venue status" required hint={hintText('prospects skip the address')}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            background: 'var(--nb-surface)',
            border: '1px solid var(--nb-border)',
            borderRadius: 10,
            padding: 3,
          }}
        >
          {stages.map((m) => (
            <button
              key={m.id}
              type="button"
              onClick={() => setStage(m.id)}
              style={{
                padding: '7px 10px',
                borderRadius: 8,
                textAlign: 'left',
                border: 0,
                cursor: 'pointer',
                background: stage === m.id ? 'var(--nb-bg)' : 'transparent',
                boxShadow: stage === m.id ? '0 1px 2px rgba(0,0,0,.08)' : 'none',
              }}
            >
              <div
                style={{
                  fontSize: 11.5,
                  fontWeight: 700,
                  color: stage === m.id ? 'var(--nb-ink)' : 'var(--nb-muted)',
                }}
              >
                {m.label}
              </div>
              <div style={{ fontSize: 9.5, color: 'var(--nb-subtle)', marginTop: 1 }}>{m.hint}</div>
            </button>
          ))}
        </div>
      </Field>
      <Field label="Venue name" required error={fieldError('name')}>
        <input
          style={fieldStyle(form.fieldState('name'))}
          value={fields.name}
          onChange={edit('name')}
          placeholder="e.g. Grand Fir Brewing"
        />
      </Field>
      <Field
        label="Venue domain"
        required
        error={fieldError('domain')}
        hint={hintText('powers brand + autofill')}
      >
        <input
          style={fieldStyle(form.fieldState('domain'), { fontFamily: MONO })}
          value={fields.domain}
          onChange={edit('domain')}
          placeholder="brewery.com"
        />
      </Field>
      <EnrichmentCard form={form} />
    </div>
  );
}
